export interface EvidenceBlockProps {
  /** What the child wrote, exactly as read. Never a raw float. */
  wrote: string;
  /** The answer the question wanted. */
  answer: string;
}

export function EvidenceBlock({ wrote, answer }: EvidenceBlockProps) {
  return (
    <div className="evidence">
      <span className="evidence-item">
        <span className="evidence-key">wrote</span>
        <span className="evidence-val">{wrote}</span>
      </span>
      <span className="evidence-item">
        <span className="evidence-key">answer</span>
        <span className="evidence-val">{answer}</span>
      </span>
    </div>
  );
}
